// API related actions
export const FETCHING_WAREHOUSES_LIST = '@@toyota/FETCHING_WAREHOUSES_LIST';
export const FETCHED_WAREHOUSES_LIST = '@@toyota/FETCHED_WAREHOUSES_LIST';
export const FETCHED_WAREHOUSES_LIST_FAILED = '@@toyota/FETCHED_WAREHOUSES_LIST_FAILED';

// warehouse locations
export const CREATING_WAREHOUSE_LOCATION = '@@toyota/CREATING_WAREHOUSE_LOCATION';
export const CREATED_WAREHOUSE_LOCATION = '@@toyota/CREATED_WAREHOUSE_LOCATION';
export const CREATED_WAREHOUSE_LOCATION_FAILED = '@@toyota/CREATED_WAREHOUSE_LOCATION_FAILED';
export const ADD_WAREHOUSE_LOCATION = '@@toyota/ADD_WAREHOUSE_LOCATION';
export const REMOVE_WAREHOUSE_LOCATION = '@@toyota/REMOVE_WAREHOUSE_LOCATION';
export const CHANGE_SELECTED_LOCATION_VALUE = '@@toyota/CHANGE_WAREHOUSE_LOCATION_VALUE';
export const CHANGE_SELECTED_LOCATION_WAREHOUSES = '@@toyota/CHANGE_SELECTED_LOCATION_WAREHOUSES';
export const CHANGE_LOCATION_FILE_LOADING_STATUS = '@@toyota/CHANGE_LOCATION_FILE_LOADING_STATUS';
export const LOAD_WAREHOUSE_LOCATIONS_FILE = '@@toyota/LOAD_WAREHOUSE_LOCATIONS_FILE';
export const GETTING_LOCATIONS_USAGE = '@@toyota/GETTING_LOCATIONS_USAGE';
export const GOTTEN_LOCATIONS_USAGE = '@@toyota/GOTTEN_LOCATIONS_USAGE';
export const GOTTEN_LOCATIONS_USAGE_FAILED = '@@toyota/GOTTEN_LOCATIONS_USAGE_FAILED';
export const GETTING_FREE_LOCATIONS = '@@toyota/GETTING_FREE_LOCATIONS';
export const GOTTEN_FREE_LOCATIONS = '@@toyota/GOTTEN_FREE_LOCATIONS';
export const GOTTEN_FREE_LOCATIONS_FAILED = '@@toyota/GOTTEN_FREE_LOCATIONS_FAILED';
export const DELETING_WAREHOUSE_LOCATIONS = '@@toyota/DELETING_WAREHOUSE_LOCATIONS';
export const DELETED_WAREHOUSE_LOCATIONS = '@@toyota/DELETED_WAREHOUSE_LOCATIONS';
export const DELETED_WAREHOUSE_LOCATIONS_FAILED = '@@toyota/DELETED_WAREHOUSE_LOCATIONS_FAILED';
export const RELEASING_WAREHOUSE_LOCATIONS = '@@toyota/RELEASING_WAREHOUSE_LOCATIONS';
export const RELEASED_WAREHOUSE_LOCATIONS = '@@toyota/RELEASED_WAREHOUSE_LOCATIONS';
export const RELEASED_WAREHOUSE_LOCATIONS_FAILED = '@@toyota/RELEASED_WAREHOUSE_LOCATIONS_FAILED';

// warehouse locations assignment
export const CLEAR_LOCATIONS_ASSIGNMENT = '@@toyota/CLEAR_LOCATIONS_ASSIGNMENT';
export const ADD_LOCATION_ASSIGNMENT = '@@toyota/ADD_LOCATION_ASSIGNMENT';
export const REMOVE_LOCATION_ASSIGNMENT = '@@toyota/REMOVE_LOCATION_ASSIGNMENT';
export const UPDATE_ASSIGNMENT_VALUE = '@@toyota/UPDATE_ASSIGNMENT_VALUE';
export const CHECKING_ASSIGNMENT_IMPORT = '@@toyota/CHECKING_ASSIGNMENT_IMPORT';
export const CHECKED_ASSIGNMENT_IMPORT = '@@toyota/CHECKED_ASSIGNMENT_IMPORT';
export const CHECKED_ASSIGNMENT_IMPORT_FAILED = '@@toyota/CHECKED_ASSIGNMENT_IMPORT_FAILED';
export const GETTING_ASSIGNMENTS_LIST = '@@toyota/GETTING_ASSIGNMENTS_LIST';
export const GOTTEN_ASSIGNMENTS_LIST = '@@toyota/GOTTEN_ASSIGNMENTS_LIST';
export const GOTTEN_ASSIGNMENTS_LIST_FAILED = '@@toyota/GOTTEN_ASSIGNMENTS_LIST_FAILED';
export const GETTING_PART_ASSIGNMENT = '@@toyota/GETTING_PART_ASSIGNMENT';
export const GOTTEN_PART_ASSIGNMENT = '@@toyota/GOTTEN_PART_ASSIGNMENT';
export const GOTTEN_PART_ASSIGNMENT_FAILED = '@@toyota/GOTTEN_PART_ASSIGNMENT_FAILED';
export const SUBMITTING_LOCATIONS_ASSIGNMENT = '@@toyota/SUBMITTING_LOCATIONS_ASSIGNMENT';
export const SUBMITTED_LOCATIONS_ASSIGNMENT = '@@toyota/SUBMITTED_LOCATIONS_ASSIGNMENT';
export const SUBMITTED_LOCATIONS_ASSIGNMENT_FAILED = '@@toyota/SUBMITTED_LOCATIONS_ASSIGNMENT_FAILED';
export const CLEAR_LOCATIONS_TO_PRINT = '@@toyota/CLEAR_LOCATIONS_TO_PRINT';
export const CLEAR_LOCATIONS = '@@toyota/CLEAR_LOCATIONS';
export const PRINT_WAREHOUSE_LOCATIONS_LABELS = '@@toyota/PRINT_WAREHOUSE_LOCATIONS_LABELS';
export const FETCHING_PART_REPLACEMENT = '@@toyota/FETCHING_PART_REPLACEMENT';
export const FETCHED_PART_REPLACEMENT = '@@toyota/FETCHED_PART_REPLACEMENT';
export const FETCHED_PART_REPLACEMENT_FAILED = '@@toyota/FETCHED_PART_REPLACEMENT_FAILED';
export const SHOW_NEW_LOCATIONS_MODAL = '@@toyota/SHOW_NEW_LOCATIONS_MODAL';
export const HIDE_NEW_LOCATIONS_MODAL = '@@toyota/HIDE_NEW_LOCATIONS_MODAL';
export const SHOW_NEW_RESERVED_LOCATIONS_MODAL = '@@toyota/SHOW_NEW_RESERVED_LOCATIONS_MODAL';
export const HIDE_NEW_RESERVED_LOCATIONS_MODAL = '@@toyota/HIDE_NEW_RESERVED_LOCATIONS_MODAL';

// warehouse allocations
export const RESET_WAREHOUSE_ALLOCATIONS = '@@toyota/RESET_WAREHOUSE_ALLOCATIONS';
export const GETTING_WAREHOUSE_ALLOCATIONS = '@@toyota/GETTING_WAREHOUSE_ALLOCATIONS';
export const GOTTEN_WAREHOUSE_ALLOCATIONS = '@@toyota/GOTTEN_WAREHOUSE_ALLOCATIONS';
export const GOTTEN_WAREHOUSE_ALLOCATIONS_FAILED = '@@toyota/GOTTEN_WAREHOUSE_ALLOCATIONS_FAILED';
export const CHANGE_WAREHOUSE_ALLOCATIONS_PAGE = '@@toyota/CHANGE_WAREHOUSE_ALLOCATIONS_PAGE';
export const CHANGE_WAREHOUSE_ALLOCATIONS_PAGE_SIZE = '@@toyota/CHANGE_WAREHOUSE_ALLOCATIONS_PAGE_SIZE';
export const CLEAR_SELECTED_LOCATIONS = '@@toyota/CLEAR_SELECTED_LOCATIONS';
export const UPDATE_SELECTED_LOCATIONS = '@@toyota/UPDATE_SELECTED_LOCATIONS';
export const DOWNLOADING_WAREHOUSE_ALLOCATIONS = '@@toyota/DOWNLOADING_WAREHOUSE_ALLOCATIONS';
export const DOWNLOADED_WAREHOUSE_ALLOCATIONS = '@@toyota/DOWNLOADED_WAREHOUSE_ALLOCATIONS';
export const DOWNLOADED_WAREHOUSE_ALLOCATIONS_FAILED = '@@toyota/DOWNLOADED_WAREHOUSE_ALLOCATIONS_FAILED';

// warehouse available
export const SETTING_AVAILABLE_WAREHOUSE_LOCATIONS = '@@toyota/SETTING_AVAILABLE_WAREHOUSE_LOCATIONS';
export const SET_AVAILABLE_WAREHOUSE_LOCATIONS = '@@toyota/SET_AVAILABLE_WAREHOUSE_LOCATIONS';
export const SET_AVAILABLE_WAREHOUSE_LOCATIONS_FAILED = '@@toyota/SET_AVAILABLE_WAREHOUSE_LOCATIONS_FAILED';
